export const PILOT_STORAGE_KEY = '24k-infinity-ui-design-v2';

/** Infinity uses the new interface for every browser, including old classic links. */
export function readPilotPreference(): boolean {
  return true;
}

export function savePilotPreference(): void {
  try { window.localStorage.setItem(PILOT_STORAGE_KEY, 'pilot'); } catch { /* Session remains usable without storage. */ }
  // Remove the consumed opt-in parameter, keeping route, other filters and hash.
  const url = new URL(window.location.href);
  if (url.searchParams.has('infinityUi')) {
    url.searchParams.delete('infinityUi');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }
}
